/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    $('.reviews_slider').slick({
        dots: true,
        infinite: true,
        speed: 1000,
        arrows: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: $('.prev_review'),
        nextArrow: $('.next_review'),
        autoplay: true,
        autoplaySpeed: 4000
    });

    $('.usps .container .row').slick({
        dots: false,
        infinite: true,
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        adaptiveHeight: true,
        responsive: [
            /* jshint ignore:start */
            {
                breakpoint: 9999,
                settings: 'unslick'
            }, {
                breakpoint: 1091,
                settings: 'slick'
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
            /* jshint ignore:end */
        ]
    });

    $(window).resize(function() {
        $('.usps .container .row').slick('resize');
    });


    $('.news .col-4 .inner').matchHeight();
    $('.news-overview .col-4 .inner').matchHeight();
    $('.diensten .col-4 .inner h3').matchHeight();
    $('.diensten .col-4 .inner p').matchHeight();
    $('.tariff.zak .inner').matchHeight();
    $('.services .inner').matchHeight();
    $('.tariff .small .inner').matchHeight('+100px');

    setTimeout(function() {
        $('.load-overlay').velocity('fadeOut', { delay: 100, duration: 300 });
    }, 100);


    if ($('#map').length > 0) {
        mapboxgl.accessToken = 'pk.eyJ1IjoiZ29vc2V2cG4iLCJhIjoiY2oxeG10YW50MDAwbTJ3cGcydncwN2IycyJ9.NJPaVrZmevgSTBEWYtwLdQ';

        var center = $('#map').attr('data-geo').split(',');

        var map = new mapboxgl.Map({
            container: 'map', // container id
            style: 'mapbox://styles/mapbox/streets-v9', //stylesheet location
            center: center,
            zoom: $('#map').attr('data-zoom'),
            bearing: 27,
            pitch: 55,
            scrollZoom: false,
            boxZoom: false,
            interactive: false,
            doubleClickZoom: false
        });
    }

    $("#nav-toggle").click(function() {
        $("#menu-topbar").slideToggle("slow", function() {});
    });


    $('.pull_down').toggle(
        function() {
            $('.bottom-bar').animate({
                marginTop: "0px",
            }, 500);
        },
        function() {
            $('.bottom-bar').animate({
                marginTop: "-50px",
            }, 500);
        }
    );


    // add .liquid to set img as background of parent div
    $(document).ready(function(){
        $('.liquid').imgLiquid();
    });
    
})(jQuery); // Fully reference jQuery after this point.
